import { Api } from "../api.service";
import { ApiTranslate } from "@/utils/decorators";
import { SecretHash } from "~/secret_hash";

/**
 * @description Class describes business logic
 * for changing user email, confirmation and etc
 */
export class EmailService {
  @ApiTranslate
  public static async changeEmail(email: string): Promise<MessageValue> {
    await Api.put("/auth/organization/email", {
      email,
    });
    return {
      result: true,
    };
  }

  public static async resendEmail() {
    await Api.put("/auth/organization/email/resend");
  }

  public static async setPassword() {
    await Api.get("/auth/organization/email/setPassword");
  }

  public static async restorePassword(email: string, bin: string) {
    const res = await Api.get(
      `/auth/organization/email/restorePassword/${email}/${bin}`,
    );
    return res.data;
  }

  public static async isSercretHashExists(
    secretHash: string,
  ): Promise<SecretHash> {
    const res = await Api.post("/auth/organization/email/isSercretHashExists", {
      secretHash,
    });
    return res.data;
  }

  public static async updatePassword(secretHash: string, password: string) {
    const res = await Api.post("/auth/organization/email/updatePassword", {
      secretHash,
      password,
    });
    return res.data;
  }

  @ApiTranslate
  public static async verify(secretHash: string): Promise<MessageValue> {
    const response = await Api.put("/auth/organization/email/confirm", {
      secretHash,
    });
    return {
      result: response.data,
    };
  }

  @ApiTranslate
  public static async verifyUserEmail(
    secretHash: string,
  ): Promise<MessageValue> {
    const response = await Api.put("/users-management/email/confirm", {
      secretHash,
    });
    return {
      result: response.data,
    };
  }
}
